import React, {Component} from 'react';
import {Table} from 'reactstrap';
import {toast} from 'react-toastify';
import {isEmpty} from 'lodash';

import {getPermission, getUser} from '../../utils/TokenManager';
import {TIME_SHEET} from "../common/Constants";
import ErrorMsg from "../common/ErrorMsg";
import EditTimeSheet from "./editTimeSheet";
import PeriodSelectionModal from "./PeriodSelection";
import DefaultHoliday from "./DefaultHoliday";


export default class DailyAttendance extends Component {
    state = {
        attendanceSheet: [],
        editTimeSheet: false,
        printTimeSheet: false,
        timeSheetSummary:false,
        showHoliday:false,
        isFormLoading:false,
    };

    auth = {
		user: getUser(),
		permission: getPermission()[TIME_SHEET]
	}

    componentDidMount = () => {
        if (this.props.agencyLocation) {
            console.log(this.props)
            this.getInitialState();
        }
    };

    getInitialState = async () => {
        if (this.auth.permission.can_view) {
            try {
                await this.props.getAttendanceSheet(this.props.agencyLocation);

                let attendanceSheet = this.props.dailyAttendance.timesheet.map(
                    timesheet => ({...timesheet})
                );
                this.setState({attendanceSheet});
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>);
            }
        }
    };

    toggleModal = (reload) => {
        this.setState((prevState) => ({editTimeSheet: !prevState.editTimeSheet}));
        if (reload) {
            this.getInitialState();
        }
    };

    openEditTimeSheet = () => {
        this.setState({editTimeSheet: true});
    };

    toggleTr = async(e, cl) => {
        [].forEach.call(document.querySelectorAll('.' + cl), function (el) {
            if (e.currentTarget.classList.contains('fa-caret-right')) {
                el.className = cl + ' d-none';
            } else {
                el.className = cl;
            }
        });
        if (e.currentTarget.classList.contains('fa-caret-right')) {
            e.currentTarget.className = 'fa font-18 px-1 fa-caret-down cursor-pointer float-right';
        } else {
            e.currentTarget.className = 'fa font-18 px-1 fa-caret-right cursor-pointer float-right';
        }
    }

   
    openPrintModal = () => {
        this.setState({printTimeSheet: true});
    };
    

    openSummaryModal = () => {
        this.setState({timeSheetSummary: true});
    };

    togglePrintModal = () => {
        this.setState((prevState) => ({printTimeSheet: !prevState.printTimeSheet}));
    };

    toggleSummaryModal = () => {
        this.setState((prevState) => ({timeSheetSummary: !prevState.timeSheetSummary}));

    }
    openHolidayModal = () => {
        this.setState({showHoliday: true});
    }
    closeHolidayModal = () => {
        this.setState({showHoliday: false});
    }
    // refreshPTOInfos = () => {
    //     this.setState(
    //         {isFormLoading: true}, () => {
    //             const timer = setTimeout(() => {
    //                 this.setState({isFormLoading: false});
    //             }, 300);
    //             return () => clearTimeout(timer);
    //         }
    //     );
    // }

    render() {
        const {attendanceSheet, editTimeSheet,showHoliday, printTimeSheet, timeSheetSummary} = this.state;
        let getYear = () => {
            let currentYear = new Date().getFullYear();
            return currentYear;
        };
        let timesheet = [];
        if (!(isEmpty(attendanceSheet))) {
            let user_id = 0;
            attendanceSheet.map((sheet, index) => {
                if (user_id === sheet.user) {
                    timesheet.push(             
                        <tr key={index} className={"user-"+sheet.user+" d-none"}>
                            <td className="border-top-0 border-left"></td>
                            <td className="text-center border-left">{sheet.clock_in}</td>
                            <td className="text-center border-left">{sheet.clock_out}</td>
                            <td className="text-center border-left border-right">
                                {sheet.reason}
                            </td>
                        </tr>
                    );
                } else {
                    timesheet.push(             
                        <tr key={index} className="table-border-2">
                            <td className="border-left">
                                {sheet.user_name} 
                                {attendanceSheet[index+1] && 
                                    attendanceSheet[index+1].user === sheet.user ? 
                                    <i className="fa font-18 px-1 fa-caret-down 
                                        cursor-pointer float-right" 
                                        onClick={(e)=>this.toggleTr(e, "user-"+sheet.user)}
                                    ></i>: ''
                                }
                            </td>
                            <td className="text-center border-left">
                                {sheet.clock_in}
                            </td>
                            <td className="text-center border-left">
                                {sheet.clock_out}
                            </td>
                            <td className="text-center border-left border-right">
                                {sheet.reason}
                            </td>
                        </tr>
                    );
                }
                user_id = sheet.user;
            });
        }
        
        return (
            this.auth.permission.can_view ?
            <div className="tab-pane" role="tabpanel">
                <ul className="secondary-menu text-right mb-1">
                    {this.auth.permission.can_edit &&
                        <li onClick={this.openSummaryModal}>
                        <a className="text-info">Print Timesheet Summary</a>
                        </li>
                    }
                    {this.auth.permission.can_edit &&
                        <li onClick={this.openEditTimeSheet}>
                            <a className="text-info"> Edit Timesheet</a>
                        </li>
                    }
                    {this.auth.permission.can_view &&
                        <li onClick={this.openPrintModal}>
                            <a className="text-info"> Print Timesheet</a>
                        </li>
                    }
                    {this.auth.permission.can_edit &&
                        <li onClick={this.openHolidayModal}>
                            <a className="text-info" >
                                Holiday
                            </a>
                        </li>
                    }
                    <li onClick={this.getInitialState} title="Reload list">
                        <a className="text-info"> <span className="fa fa-refresh"></span></a>
                    </li>
                </ul>
                <Table responsive size="sm" className="mb-0">
                    <thead className="bg-light border">
                        <tr>
                            <th className="border-top-0 pb-1 font-weight-bold w-30">Staff Name</th>
                            <th className="border-top-0 pb-1 font-weight-bold text-center">Time In</th>
                            <th className="border-top-0 pb-1 font-weight-bold text-center">Time Out</th>
                            <th className="border-top-0 pb-1 font-weight-bold text-center">Reason</th>
                        </tr>
                    </thead>
                    <tbody className="border-bottom">
                        {timesheet}
                    </tbody>
                </Table>
                
                {editTimeSheet &&
                    <EditTimeSheet {...this.props} modal={editTimeSheet} 
                        toggleModal={this.toggleModal} isEnableStaffSelection={true} 
                    />
                }

                {(printTimeSheet || timeSheetSummary) &&
                    <PeriodSelectionModal {...this.props} 
                        modal={printTimeSheet || timeSheetSummary} 
                        toggleModal={() => {
                            timeSheetSummary ? 
                                this.toggleSummaryModal()
                                : this.togglePrintModal() 
                        }} 
                        adminDashboard={true}
                        staffname={!timeSheetSummary}
                    />
                }
                {showHoliday && 
                    <DefaultHoliday {...this.props} 
                        modal={showHoliday}
                        toggleModal={this.closeHolidayModal} 
                        year = {getYear()}
                        permission={this.auth.permission}
                        refreshPTOInfos={this.refreshPTOInfos}
                    />
                }

            </div>
            : <div className="tab-pane text-center" role="tabpanel">
                Access Denied
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/daliyAttendance/attendanceSheet.js